import React from "react";
import { ProfileDepartmentInfoComponent } from "../../../services/types/ComponentTypes";

interface ProfileDepartmentInfoProps {
    component: ProfileDepartmentInfoComponent;
    formData: any;
}

const ProfileDepartmentInfo: React.FC<ProfileDepartmentInfoProps> = ({
    component,
    formData,
}) => {
    // Cast style to any to bypass type mismatch
    const containerStyle = { ...component.style, display: "flex", gap: 40, borderTop: "1px solid #eee", paddingTop: 24 } as any;

    return (
        <div style={containerStyle}>
            {component.fields?.map((field: any, index: number) => {
                const value = formData[field.BindValue];
                return (
                    <div key={index}>
                        <div style={{ fontSize: 12, color: "#999", textTransform: "uppercase", marginBottom: 4 }}>
                            {field.label}
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 500, color: "#333" }}>
                            {value || "-"}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ProfileDepartmentInfo;
